/**
 * Отрезок масштаба подложки, пока его ведут: от первой точки к курсору, с засечками
 * на концах и длиной в текущем масштабе. Мышь сквозь него проходит — клик ловит холст.
 */
import { dist, formatMillimeters, type Pt } from "@/shared/lib/geometry";
import { useLengthUnit } from "@/shared/store";

const COLOR = "#2f6feb";

interface Props {
	from: Pt;
	to: Pt;
	mmPerPx: number;
}

export const UnderlayScaleLine = ({ from, to, mmPerPx }: Props) => {
	const unit = useLengthUnit();
	const px = (n: number) => n * mmPerPx;
	const length = dist(from, to);
	const label = formatMillimeters(length, unit);
	const fontSize = px(12);
	const boxWidth = label.length * fontSize * 0.6 + px(12);
	const boxHeight = fontSize + px(8);
	const mid = { x: (from.x + to.x) / 2, y: (from.y + to.y) / 2 };
	return (
		<g data-plan-export-exclude style={{ pointerEvents: "none" }}>
			<line
				x1={from.x}
				y1={from.y}
				x2={to.x}
				y2={to.y}
				stroke={COLOR}
				strokeWidth={px(2)}
				strokeDasharray={`${px(6)} ${px(4)}`}
			/>
			{[from, to].map((p, i) => (
				<circle
					// Концы отрезка — первый и второй, порядок не меняется
					key={i}
					cx={p.x}
					cy={p.y}
					r={px(5)}
					fill="#ffffff"
					stroke={COLOR}
					strokeWidth={px(2)}
				/>
			))}
			{length >= 1 && (
				<>
					<rect
						x={mid.x - boxWidth / 2}
						y={mid.y - boxHeight / 2}
						width={boxWidth}
						height={boxHeight}
						rx={px(4)}
						fill="#ffffff"
						stroke={COLOR}
						strokeWidth={px(1)}
					/>
					<text
						x={mid.x}
						y={mid.y}
						textAnchor="middle"
						dominantBaseline="central"
						fontSize={fontSize}
						fontWeight={600}
						fill={COLOR}
						style={{ userSelect: "none" }}
					>
						{label}
					</text>
				</>
			)}
		</g>
	);
};
